module.exports = __webpack_public_path__ + "img/neighborhood-otr.64c1808b.jpg";